import { lazy } from "react";

const DuelPage = lazy(() => import("./ui/DuelPage/DuelPage"));

export { DuelPage };
